namespace Solovis.Reports {

    export interface ReportConfigControlOptions extends Solovis.UI.BaseControlOptions {
        reportControl: Solovis.Reports.ReportControl;
        uiOptions: any;
        alwaysHideRunButton?: boolean;
    }

    export class ReportConfigControl extends Solovis.UI.BaseControl {

        public _reportControl: Solovis.Reports.ReportControl;
        public _uiOptions;
        public _alwaysHideRunButton;

        public _paramListElement: JQuery;
        public _paramListControlHost: Solovis.UI.ControlHost;
        public _paramListControl: Solovis.Reports.Parameters.ParameterListControl;
        public _runDiv: JQuery;
        public runButton: JQuery;


        constructor(options: ReportConfigControlOptions) {
            super(options);

            this._reportControl = options.reportControl;
            this._uiOptions = options.uiOptions;
            this._alwaysHideRunButton = options.alwaysHideRunButton ? true : false;
        }

        public doInit() {
        }

        public doRender() {
            if (this.options.renderMode === 'modern') {
                this.doRenderNew();
            } else {
                this.doRenderClassic();
            }
        }

        public doRenderNew() {
            this.doRenderClassic('modern');
            this._runDiv.addClass("slvs-panel-footer");
            this.runButton.addClass("slvs-btn slvs-btn-primary").text("Run Report");
        }

        public doRenderClassic( renderMode?: Solovis.UI.BaseControlOptions['renderMode']) {
            let self = this;
            let reportControl = this._reportControl;

            this._runDiv = $("<div>");
            this.runButton = $("<button>");

            this.runButton.text("Run");

            // Set up parameters input UI and report run button.        
            this._paramListElement = $("<div>").appendTo(this.container);

            this._paramListControlHost = new Solovis.UI.ControlHost({ container: this._paramListElement });
            this._paramListControl = new Solovis.Reports.Parameters.ParameterListControl({
                parameterSet: this._reportControl._parameterSet,
                restrictedParameterOptions: this._reportControl._restrictedParameterOptions,
                portalServices: this._reportControl.portalServices(),
                renderMode: renderMode
            });
            this._paramListControlHost.setCurrentControl(this._paramListControl);

            // Run section.
            this._runDiv.addClass("report-control-run-button-section").appendTo(this.container);
            if (this._uiOptions.hideRunOptions || this._alwaysHideRunButton) {
                this._runDiv.css("display", "none");
            }

            // Run button
            if (!this._uiOptions.hideRunButton) {
                let runButtonDiv = $("<div>").css("display", "inline-block").css("vertical-align", "top").appendTo(this._runDiv);
                this.runButton.appendTo(runButtonDiv);
                this.runButton.click(() => {
                    this._reportControl.runReport();
                });

                $(this.runButton).bind("contextmenu", (e) => {
                    e.preventDefault();
                    e.cancelBubble = true;

                    let runContextMenuLinks: Solovis.UI.PopupLinkPanelLink[] = [];

                    runContextMenuLinks.push({
                        label: "Run",
                        click: () => this._reportControl.runReport()
                    });

                    runContextMenuLinks.push({
                        label: "Run (Ignore Currently Cached Data)",
                        click: () => this._reportControl.runReport({
                            doNotUseCache: true
                        })
                    });

                    runContextMenuLinks.push({
                        separator: true
                    });

                    runContextMenuLinks.push({
                        label: "Advanced",
                        links: [
                            {
                                label: "Hidden Part Overrides",
                                click: () => { this._reportControl.showPartHiddenOverrideDialog(); }
                            }
                        ]
                    });

                    Solovis.UI.PopupLinkPanel.showLinks({
                        links: runContextMenuLinks,
                        offset: { left: e.pageX, top: e.pageY }
                    });

                    return false;
                });
            }

            // We will trigger an event on the report control when someone drops a parameter label on a parameter label on this report.
            $(this._paramListControl).bind("parameterLabelOnParameterLabelDrop", (function (e, data) {
                // Add target report control to the data and refire on the report control itself.
                data.reportControl = self._reportControl;
                $(self._reportControl).trigger("parameterLabelOnParameterLabelDrop", data);
            } as any));
        }


        public doDestroy() {
            if (this._paramListControlHost) {
                this._paramListControlHost.setCurrentControl(null);
            }
        }
    }

}
    